// Debounced live-submit for admin search inputs (e.g. the moderation index).
let searchTimer
document.addEventListener('input', (event) => {
  const input = event.target.closest('input[data-mod-search]')
  if (!input || !input.form) return
  clearTimeout(searchTimer)
  searchTimer = setTimeout(() => input.form.requestSubmit(), 300)
})
